import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../core/configs/app-config';
import {SelectItem} from 'primeng/api';
import {Onderwerp} from '../../../../model/dto/planning/onderwerp';
import {DatePipe} from '@angular/common';
import {UserService } from "../../../../core/services/user.service";
import {MatDatepicker} from '@angular/material/datepicker';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as english } from '../i18n/en';
import { locale as dutch } from '../i18n/nl';
import {formatDate} from '@angular/common';
@Component({
    selector: 'bewerken-dialog',
    templateUrl: 'bewerkendialog.component.html',
    styleUrls  : ['./bewerkendialog.component.scss']
  })
  export class PlanningMdwBewerkenDialog {
  public get dialogRef(): MatDialogRef<PlanningMdwBewerkenDialog> {
    return this._dialogRef;
  }
  public set dialogRef(value: MatDialogRef<PlanningMdwBewerkenDialog>) {
    this._dialogRef = value;
  }

    selectedBedrijfID: any;
    onderwerpItem: Onderwerp;
    rbMedewerkers: number;
    cbMaandag: boolean;
    headerText: string;
    cbDinsdag: boolean;
    cbWoensdag: boolean;
    cbDonderdag: boolean;
    cbVrijdag: boolean;
    cbZaterdag: boolean;
    cbZondag: boolean;
    activiteiten: SelectItem[] = [];
    selectedMedewerkers: SelectItem[] = [];
    startdatumvalue: Date;
    bedrijven: SelectItem[] = [];
    Medewerkers: SelectItem[] = [];
    medewerkerFuncties: SelectItem[] = [];
    config: any;
    planningID: number = 0;
    medewerkerID: number = 0; 
    aktie: number = 0;
    onlyToday: boolean;
    toonHerhalingWeek: boolean = false;
    startTijd: string = '00:00';
    totTijd: string= '00:00';
    constructor(private _fuseTranslationLoaderService: FuseTranslationLoaderService,public datepipe: DatePipe, private _dialogRef: MatDialogRef<PlanningMdwBewerkenDialog>,private userService:UserService,@Inject(MAT_DIALOG_DATA) public data:  any[], @Inject(HttpClient) private http?: HttpClient,) {
      this.config = {
        "SERVERPROTOCOL": AppConfig.ApiProtocol,
        "SERVERURL": AppConfig.ApiLoginHost,
        "SERVERPORT": AppConfig.ApiPort,
        "APPLICATIONID": AppConfig.ApiApplicationId,
        "METHOD": AppConfig.ApiMethod,
        "LOGINURL": AppConfig.ApiLoginUrl,
        "STACKURL": AppConfig.ApiUrl
      };
      this._fuseTranslationLoaderService.loadTranslations(english, dutch);
      if (this.data["calEvent"]["id"] > 0) {
        this.planningID = this.data["calEvent"]["id"];
      }
      
      if (this.data["calEvent"]["resourceId"] > 0) {
        this.medewerkerID = this.data["calEvent"]["resourceId"];
      }

      try {
        this.startdatumvalue = this.data["calEvent"]["start"]["_i"];
      } catch (e) {
        this.startdatumvalue = this.data["calEvent"]["_d"];
      }
      
      console.log(this.startdatumvalue);
      this.onlyToday = this.data["onlyToday"];

      console.log(this.planningID);
      if (this.planningID == 0) {
        if(this.medewerkerID == 0){
          this.aktie = 2;
        } else {
          this.aktie = 0;
        }
      } else {
          if (this.medewerkerID == 0){
          this.aktie = 1;
        } else {
          this.aktie = 0;
        }
      }
     }

      ngOnInit() {

        switch(this.aktie){
          case 0:
          // nieuw item voor een meegegeven medewerker op meegegeven planning
          {
          this.headerText = "Planning bewerken";
          this.onderwerpItem = new Onderwerp();
          this.onderwerpItem.Start = new Date(this.startdatumvalue)
          this.onderwerpItem.Tot = new Date();
          this.onderwerpItem.Tot.setDate(this.onderwerpItem.Start.getDate() + 1)

          break;
          }
          case 1:
          // planning zonder meegegeven medewerkers
          {
          this.headerText = "Nieuw planning";
          this.onderwerpItem = new Onderwerp();
          this.onderwerpItem.Start = new Date(this.startdatumvalue)
          this.onderwerpItem.Start.setHours(0);
          this.onderwerpItem.Start.setMinutes(0);
          this.onderwerpItem.Start.setSeconds(0);

          this.onderwerpItem.Tot = new Date();
          this.onderwerpItem.Tot.setDate(this.onderwerpItem.Start.getDate() + 1); 
          this.onderwerpItem.Tot.setHours(0);
          this.onderwerpItem.Tot.setMinutes(0);
          this.onderwerpItem.Tot.setSeconds(0);
          break;
          }
          case 2:
          {
          // nieuw item geen planning en geen medewerkers
          this.headerText = "Nieuw planning";

          this.onderwerpItem = new Onderwerp();
          this.onderwerpItem.Start = new Date(this.startdatumvalue)
          this.onderwerpItem.Start.setHours(0);
          this.onderwerpItem.Start.setMinutes(0);
          this.onderwerpItem.Start.setSeconds(0);

          this.onderwerpItem.Tot = new Date();
          this.onderwerpItem.Tot.setDate(this.onderwerpItem.Start.getDate() + 1); 
          this.onderwerpItem.Tot.setHours(0);
          this.onderwerpItem.Tot.setMinutes(0);
          this.onderwerpItem.Tot.setSeconds(0);

 
          break;
          }

        }
      
        

        // urencategories inladen  
        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/urencategorie/overzicht";
        if (JSON.parse(localStorage.getItem('activiteiten')) != null) {
          this.activiteiten = JSON.parse(localStorage.getItem('activiteiten'));
        } else {
          var get = this.http.get(conString);
          get.subscribe(     
          (results:any) => {
            this.activiteiten.push(<SelectItem>{ label:"Selecteer een urencategorie", value:0});
            for (var result of  results){ 
              this.activiteiten.push(<SelectItem>{ label:result["Categorie"], value:result["UrenCatID"]});
            }  
            localStorage.setItem('activiteiten', JSON.stringify(this.activiteiten));
          },
          (error) => {
          console.error(error);
          });
        }
   
        
        // bedrijven inladen
        if (JSON.parse(localStorage.getItem('bedrijven')) != null) {
          this.bedrijven = JSON.parse(localStorage.getItem('bedrijven'));
          this.loadInfo();

    
          console.log(this.bedrijven);
        } else {
          conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/bedrijven/overzicht";

          var get = this.http.get(conString);
          get.subscribe(     
          (results:any) => {
            this.bedrijven.push(<SelectItem>{ label:"Selecteer een bedrijf", value:0});
          for (var result of  results){ 
            this.bedrijven.push(<SelectItem>{ label:result["Bedrijf"], value:result["BedrijfID"]});
          }  
          localStorage.setItem('bedrijven', JSON.stringify(this.bedrijven));
            this.loadInfo();
          },
          (error) => {
          console.error(error);
          });
        }
        

        // medewerkers inladen
        if (JSON.parse(localStorage.getItem('medewerkers')) != null) {
          this.Medewerkers = JSON.parse(localStorage.getItem('medewerkers'));
        }else{
          conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/planable";

          var get = this.http.get(conString);
          get.subscribe(     
          (results:any) => {
          for (var result of  results){ 
              this.Medewerkers.push(<SelectItem>{ label:result["CplNaam"] + " (" + result["Afdeling"].substring(0,3) + ")", value:result["MedewerkerID"], });
          }  
           localStorage.setItem('medewerkers', JSON.stringify(this.Medewerkers));
          },
          (error) => {
          console.error(error);
          });
        }
        

            // medewerkers functies inladen

            if (JSON.parse(localStorage.getItem('medewerkerFuncties')) != null) {
              this.medewerkerFuncties = JSON.parse(localStorage.getItem('medewerkerFuncties'));
            } else {
              conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/functies";

              var get = this.http.get(conString);
              get.subscribe(     
              (results:any) => {
                this.medewerkerFuncties.push(<SelectItem>{ label:"Selecteer een functie", value:0});
              for (var result of results){ 
                  this.medewerkerFuncties.push(<SelectItem>{ label:result["Description"], value:result["FunctieID"], });
              }  
              localStorage.setItem('medewerkerFuncties', JSON.stringify(this.medewerkerFuncties));
              },
              (error) => {
              console.error(error);
              });
            }

      
      }

        loadInfo(){
         var body = {
           "PlanningID": this.planningID
          };
         let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/edit/objectinfo";

             var post = this.http.post(conString, body);
             post.subscribe(     
             (results:any) => {
             for (var result of  results){ 
               this.onderwerpItem.Onderwerp = result["Onderwerp"];
               this.onderwerpItem.OnderwerpID = result["OnderwerpID"];
               this.onderwerpItem.UrenCatID = result["UrenCatID"];
               this.onderwerpItem.BedrijfID = result["BedrijfID"];
               this.onderwerpItem.Notitie = result["Notitie"];              
               if (this.onlyToday == true) {
                this.onderwerpItem.Patroon = 0 
                this.toonHerhalingWeek = false;
                this.onderwerpItem.Weken = 0
               } else {
                this.onderwerpItem.Patroon = result["Patroon"];
                this.onderwerpItem.Weken = result["Weken"];              
               }

               if (result["Patroon"] == 2) {
                this.toonHerhalingWeek = true;
               }


               // 1 dag
               if (result["Patroon"] == 0 ){       
                this.onderwerpItem.Tot = new Date(result["Tot"]);       
                this.startTijd = this.onderwerpItem.Start.toTimeString().substring(0,5);
                this.totTijd = this.onderwerpItem.Tot.toTimeString().substring(0,5);
               } 
               
               
               
               this.onderwerpItem.FunctieID = result["FunctieID"];
             }  
             this.loadSelectedMedewerkers();

             if (this.onlyToday == false) {
               
              this.loadSerieInfo(); 
              this.startTijd = this.onderwerpItem.Start.toTimeString().substring(0,5);
              console.log(this.startTijd);
              this.totTijd = this.onderwerpItem.Tot.toTimeString().substring(0,5);
            } 
             
             },
             (error) => {
             console.error(error);
             });

        }
        
        loadSerieInfo() {
         var body = {
           "OnderwerpID": this.onderwerpItem.OnderwerpID
          };
         let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/edit/serieinfo";

             var post = this.http.post(conString, body);
             post.subscribe(     
             (results:any) => {
               console.log(results);
             for (var result of  results){    
               this.onderwerpItem.Tot = result["Tot"];
             }  

             },
             (error) => {
             console.error(error);
             });

             conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/edit/seriedagen";

             var post = this.http.post(conString, body);
             post.subscribe(     
             (results:any) => {
               console.log(results);
             for (var result of  results){    
               this.cbMaandag = result["Maandag"];
               this.cbDinsdag = result["Dinsdag"];
               this.cbWoensdag = result["Woensdag"];
               this.cbDonderdag = result["Donderdag"];
               this.cbVrijdag = result["Vrijdag"];
               this.cbZaterdag = result["Zaterdag"];
               this.cbZondag = result["Zondag"];

               console.log(this.cbMaandag);
             }  

             },
             (error) => {
             console.error(error);
             });
        }


        cbWekelijks(){
         if (this.onderwerpItem.Patroon == 0 ) {
          this.onderwerpItem.Patroon = 2
         }

         if (this.onderwerpItem.Weken == 0 ) {
          this.onderwerpItem.Weken = 1
         }

         this.toonHerhalingWeek = true;

        }

        loadSelectedMedewerkers(){
          // medewerkers voor onderwerp inladen
          console.log(this.onderwerpItem.OnderwerpID);

          var body = {
            "OnderwerpID": this.onderwerpItem.OnderwerpID
          };
          let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/edit/medewerkers";

          var post = this.http.post(conString, body);
          post.subscribe(     
          (results:any) => {
            console.log(results);
          for (var result of results){ 
            this.selectedMedewerkers.push(result["MedewerkerID"]);
          }     
          console.log(this.selectedMedewerkers);  
          if (this.selectedMedewerkers.length > 0){
            if (this.selectedMedewerkers[0].value == 0){
              this.rbMedewerkers = 1
            } else {
              this.rbMedewerkers = 2
            }
          }else{
            this.rbMedewerkers = 1
          }    
          },
          (error) => {
          console.error(error);
          });
        }

    btnTerug(){
      this.dialogRef.close();
      }

    btnOpslaan(){
        if (this.onderwerpItem.Onderwerp.length < 1) {
          this.onderwerpItem.Onderwerp = ""
        }

        if (this.onderwerpItem.FunctieID < 1) {
          alert("Je moet een functie invullen!"); 
        }

        if (this.onderwerpItem.Tot < this.onderwerpItem.Start) {
          alert("error eind datum moet verder liggen dan start datum!"); 
          return;
        }

        
        if (this.onderwerpItem.Start > this.onderwerpItem.Tot) {
          alert("error start datum moet eerder liggen dan eind datum!"); 
          return;
        }

        if (this.onderwerpItem.Patroon == 0) {
          if (this.onderwerpItem.Start.getDate() + 1 != this.onderwerpItem.Tot.getDate() ||  this.onderwerpItem.Start.getFullYear() != this.onderwerpItem.Tot.getFullYear()) {
            alert("error dit is alleen bedoeld voor 1 dag!"); 
            return;
          }
        }
 

        console.log(this.startTijd);

        // merge datums met tijden
        this.onderwerpItem.Start.setHours(Number(this.startTijd.substring(0,2)));
        this.onderwerpItem.Start.setMinutes(Number(this.startTijd.substring(3,5)));

        console.log(this.onderwerpItem.Start);
        this.onderwerpItem.Tot.setHours(Number(this.totTijd.substring(0,2)));
        this.onderwerpItem.Tot.setMinutes(Number(this.totTijd.substring(3,5)));

        console.log(this.selectedMedewerkers);
        var body = {
          "PlanningID": this.planningID,
          "OnderwerpID": this.onderwerpItem.OnderwerpID,
          "medewerkerIDs": this.selectedMedewerkers,
          "UrenCatID": this.onderwerpItem.UrenCatID,
          "Start": this.datepipe.transform(this.onderwerpItem.Start, 'yyyy-MM-ddTHH:mm:ssZ'),
          "Tot": this.datepipe.transform(this.onderwerpItem.Tot, 'yyyy-MM-ddTHH:mm:ssZ'),
          "BedrijfID": this.onderwerpItem.BedrijfID,
          "Onderwerp": this.onderwerpItem.Onderwerp,
          "Patroon": this.onderwerpItem.Patroon,
          "Dagen": this.onderwerpItem.Dagen,
          "Weken": this.onderwerpItem.Weken,
          "Maanden": this.onderwerpItem.Maanden,
          "Storing": this.onderwerpItem.Storing,
          "FunctieID": this.onderwerpItem.FunctieID,
          "Notitie": this.onderwerpItem.Notitie,
          "InternMonteurInfo": this.onderwerpItem.InternMonteurInfo,
        };
        console.log(body);
        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/edit/saveplanning";

        var post = this.http.post(conString, body);
        post.subscribe(     
        (results:any) => {
          console.log(results);
        for (var result of results){ 
          if (result["Succeed"] == true) {
            alert("opslaan gelukt");
            this.dialogRef.close();
          }
        }       
         
        },
        (error) => {
        console.error(error);
        });
     }

     btnVerwijderen(){

      var body = {
        "planningID": this.planningID,
        "onderwerpID": this.onderwerpItem.OnderwerpID,
        "medewerkerIDs": this.selectedMedewerkers,
        "patroon": this.onderwerpItem.Patroon,
        "onlyToday": this.onlyToday     
      };
      let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/edit/deleteplanning";

        var post = this.http.post(conString, body);
        post.subscribe(     
        (results:any) => {
          console.log(results);
          for (var result of  results){ 
            if (result["Succeed"] == true) {
              alert("verwijderen gelukt");
              this.dialogRef.close();
            }
          }
        },(error) => {
        console.error(error);
        });
     }
  }